'use client';

export { default } from './GlobalStyles';